import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import { LOCATION_DROPDOWN_STORAGE_KEYS } from "components/LocationDropdown/storageKeys";
import { PERSISTED_LOCATION_ID, persistItem } from "components/PersitanceManager";
import { typedQueryClient, useTypedQuery } from "hooks";
import { getPreference, setPreference } from "utils/common";

import type { DealerLocation } from "models";

export const useSelectedLocation = () => ({
  selectedLocation: useTypedQuery({
    queryKey: DealersAndLocationsDropdownKeys.selectedLocation,
    initialData: getPreference(LOCATION_DROPDOWN_STORAGE_KEYS.LocationSelectedPreference, null)
  }).data
});

export const setSelectedLocation = (location: DealerLocation) => {
  typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.selectedLocation, location);
  persistItem(PERSISTED_LOCATION_ID, location.id.toString());
  setPreference(LOCATION_DROPDOWN_STORAGE_KEYS.LocationSelectedPreference, location);
};
